'use client'

import React, { useCallback, useState } from 'react'

import { clearImpersonationCookies } from '@/helpers/clearImpersonationCookies'
import { getImpersonatedUser } from '@/helpers/getImpersonatedUser'

import type { Dispatch, FC, PropsWithChildren, SetStateAction } from 'react'
import type { AsmSession } from '@/interfaces/AsmSession'

interface AsmSessionContextProps extends AsmSession {
  setImpersonatedUser: Dispatch<SetStateAction<AsmSession['impersonatedUser'] | null>>
  clearImpersonation: () => void
}

export const AsmSessionContext = React.createContext<AsmSessionContextProps>({
  impersonatedUser: null,
  setImpersonatedUser: () => null,
  clearImpersonation: () => undefined,
})

const AsmSessionContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [impersonatedUser, setImpersonatedUser] = useState<AsmSession['impersonatedUser'] | null>(getImpersonatedUser())

  const clearImpersonation = useCallback(() => {
    clearImpersonationCookies()
    setImpersonatedUser(null)
  }, [])

  return (
    <AsmSessionContext.Provider
      value={{
        impersonatedUser,
        setImpersonatedUser,
        clearImpersonation,
      }}
    >
      {children}
    </AsmSessionContext.Provider>
  )
}

export default AsmSessionContextProvider
